import { useState } from 'react';
import { api, ErrorApi, type Partido } from '../services/api';
import { Boton } from './ui';

const GAMES = [0, 1, 2, 3, 4, 5, 6, 7];

/**
 * Corregir el marcador de un pendiente, en el lugar.
 *
 * Solo el marcador: si lo que está mal son los jugadores o la fecha, se
 * rechaza y se carga de nuevo, porque eso cambia quién tiene que confirmar.
 * El tanteo del tiebreak se conserva solo si el set no cambió; si cambió, se
 * borra (es opcional y nada más se muestra).
 */
export function CorregirMarcador({
  partido,
  onListo,
  onCancelar,
}: {
  partido: Partido;
  onListo: () => void;
  onCancelar: () => void;
}) {
  const [a, setA] = useState(partido.games_a);
  const [b, setB] = useState(partido.games_b);
  const [ocupado, setOcupado] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const nombres = (equipo: string) =>
    partido.jugadores
      .filter((j) => j.equipo === equipo)
      .map((j) => j.nombre)
      .join(' · ');

  const mismoSet = a === partido.games_a && b === partido.games_b;

  async function guardar() {
    setOcupado(true);
    setError(null);
    try {
      await api.corregir(partido.id, {
        games_a: a,
        games_b: b,
        tb_a: mismoSet ? partido.tb_a : null,
        tb_b: mismoSet ? partido.tb_b : null,
      });
      onListo();
    } catch (e) {
      setError(e instanceof ErrorApi ? e.message : 'No se pudo corregir.');
    } finally {
      setOcupado(false);
    }
  }

  return (
    <div className="mt-2 flex flex-col gap-2 border-t border-(--color-borde) pt-2">
      <span className="text-sm">¿Cómo terminó?</span>
      {(['A', 'B'] as const).map((equipo) => (
        <label key={equipo} className="flex items-center justify-between gap-3 text-sm">
          <span className="min-w-0 flex-1 truncate">{nombres(equipo)}</span>
          <select
            value={equipo === 'A' ? a : b}
            onChange={(e) => (equipo === 'A' ? setA : setB)(Number(e.target.value))}
            className="min-h-10 w-16 rounded-lg border border-(--color-borde) bg-(--color-panel)
              px-2 text-center text-base outline-none"
          >
            {GAMES.map((g) => (
              <option key={g} value={g}>
                {g}
              </option>
            ))}
          </select>
        </label>
      ))}
      <p className="text-xs text-(--color-apagado)">
        Queda anotado en el partido quién lo corrigió y de qué a qué. El rival lo sigue
        confirmando igual.
      </p>
      {error && <p className="text-xs text-(--color-error)">{error}</p>}
      <div className="flex gap-2">
        <Boton chico onClick={guardar} deshabilitado={ocupado || mismoSet}>
          Guardar {a}-{b}
        </Boton>
        <Boton chico tipo="secundario" onClick={onCancelar}>
          Volver
        </Boton>
      </div>
    </div>
  );
}
